import {
	EdgerRollPass,
	EdgerRollPassResponse,
} from "@/pages/catalogs/models/EdgerRoll";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Rollset, RollsetRoll } from "../models/Rollset";

export const getReadyRollsetsBySection = async (
	params: { sectionId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.sectionId)
		parameters.push({ name: "SectionId", value: params.sectionId });

	const resp = await apiService.callV2(
		"[M2].[GetReadyRollsets]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Rollset[];
	} else {
		throw new Error(resp.message || "Error fetching rollsets");
	}
};

type getRollsetRollsProps = {
	sectionId: number;
	standId: number;
	letter: string;
};

export const getRollsetRolls = async (
	params: getRollsetRollsProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionId", value: params.sectionId },
		{ name: "StandId", value: params.standId },
		{ name: "RollsetLetter", value: params.letter },
	];

	const resp = await apiService.callV2(
		"[M2].[GetRollsetRolls]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as RollsetRoll[];
	} else {
		throw new Error(resp.message || "Error fetching rolls");
	}
};

type setRollsetProps = {
	sectionId: number;
	standId: number;
	letter: string;
	topRollId: number | null;
	bottomRollId: number | null;
	sourceCode?: "M" | "R"; // M=Mill, R=Rollshop
	actionTypeCode?: "S" | "M" | "C"; // S=Swap, M=Mix, C=Create
};

export const setRollset = async ({
	sectionId,
	standId,
	letter,
	topRollId,
	bottomRollId,
	sourceCode = "R", // Default to Rollshop
	actionTypeCode = "C", // Default to Create
}: setRollsetProps) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionId", value: sectionId },
		{ name: "StandId", value: standId },
		{ name: "RollsetLetter", value: letter },
		{ name: "TopRollId", value: topRollId },
		{ name: "BottomRollId", value: bottomRollId },
		{ name: "SetAsInactive", value: false },
		{ name: "SourceCode", value: sourceCode },
		{ name: "ActionTypeCode", value: actionTypeCode },
	];

	const resp = await apiService.callV2("[M2].[UpsertRollset]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting rollset");
	}
};
